<template>
  <nav class="navbar navbar-expand-lg navbar-primary fixed-top d-lg-none bg-primary" id="nav">
    <div class="container">
      <div class="navbar-header">
        <router-link to="/" :alt="configData.general.brandName">
          <img
            :alt="configData.general.brandName"
            src="@/assets/logo.png"
            width="60px"
            style="padding-bottom: 10px;"
          />
        </router-link>
      </div>
      <button
        id="menu-toggle"
        class="navbar-toggler toggler-iff"
        aria-expanded="true"
        v-on:click="toogle()"
      >
        <i class="fa fa-bars" style="color: var(--primary-color);"></i>
      </button>
    </div>
  </nav>
</template>

<script>
import data from '@/staticData.json';

export default {
  name: 'MobileNavbar',
  data() {
    return {
      configData: data,
    };
  },
  methods: {
    toogle() {
      this.$parent.toogle();
    },
  },
};
</script>
